var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgChanged(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.36744 3.26512H3.19276C2.87642 3.26512 2.57304 3.39078 2.34935 3.61447C2.12567 3.83816 2 4.14154 2 4.45788V12.8072C2 13.1236 2.12567 13.427 2.34935 13.6506C2.57304 13.8743 2.87642 14 3.19276 14H11.5421C11.8585 14 12.1618 13.8743 12.3855 13.6506C12.6092 13.427 12.7349 13.1236 12.7349 12.8072V8.63256M11.8403 2.37054C12.0776 2.13329 12.3994 2 12.7349 2C13.0704 2 13.3922 2.13329 13.6295 2.37054C13.8667 2.6078 14 2.92959 14 3.26512C14 3.60065 13.8667 3.92244 13.6295 4.15969L7.96382 9.82532L5.57829 10.4217L6.17468 8.03618L11.8403 2.37054Z",
    stroke: "#F7526D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChanged);
export default __webpack_public_path__ + "static/media/changed.8492d01d978b0b25e13b57e3e6fd3a3b.svg";
export { ForwardRef as ReactComponent };